import Images from "./Images";

const CitizenSubServicesData = [
  {
    id: 141,
    title: "Service 14 - 1",
    link: "https://online-rathaus.einbeck.de/buergerservice/online/privat/uebersicht-0-30110.html",
    image: Images.service141,
    isExternalLink: 1,
    categoryId: 0,
  },
  {
    id: 142,
    title: "Service 14 - 2",
    link: "https://stadt-einbeck.saas.smartcjm.com/m/Buergerbuero/extern/calendar/?uid=3e5df0d1-ea60-4078-bbc4-783f5909672c&wsid=&lang=de&=wsid",
    image: Images.service142,
    isExternalLink: 1,
    categoryId: 0,
  },
  {
    id: 143,
    title: "Service 14 - 3",
    link: "https://ris.kdgoe.de/EIN_public/",
    image: Images.service143,
    isExternalLink: 0,
    categoryId: 0,
  },
  {
    id: 151,
    title: "Service 15 - 1",
    link: "https://beteiligung.einbeck.de/",
    image: Images.service151,
    isExternalLink: 0,
    categoryId: 0,
  },
  {
    id: 153,
    title: "Service 15 - 3",
    link: "https://www.einbeck.de/rathaus-politik/idee-beschwerde/",
    image: Images.service153,
    isExternalLink: 0,
    categoryId: 0,
  },
];

export default CitizenSubServicesData;
